module.exports = __webpack_public_path__ + "img/burngo-min.72f9a9a3.jpg";